export default __webpack_public_path__ + "static/media/scuba-diving.7a1c8f63.svg";